import PropTypes from 'prop-types';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { DefaultLink, Link } from 'hb-react/frontoffice/components/Link';

const NetworkLink = ({ to, ...otherProps }) => {
  const { networkRootUrl, whitelabelURL } = useTopicContext();

  return whitelabelURL ? (
    <DefaultLink
      href={`${networkRootUrl}${to}`}
      target="_blank"
      {...otherProps}
    />
  ) : (
    <Link to={to} {...otherProps} />
  );
};

NetworkLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default NetworkLink;
